<!--===========================
=            HOVER            =
============================-->

<template>
	<div>
		<v-row>
			<base-header>
				<div slot="page-header">Hovers</div>
			</base-header>
		</v-row>
		<v-row>

			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">#Open and close delay</div>
					<div slot="card-subheader">Delay v-hover events by using open-delay and close-delay props in
						combination or separately.</div>
					<div slot="card-body">
						<v-row>
							<v-col cols="12" sm="6">
								<v-hover v-slot="{ hover }" open-delay="200">
									<v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto"
											height="160" max-width="200">
										<v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
											Open Delay (Mouse enter)
										</v-card-text>
									</v-card>
								</v-hover>
							</v-col>

							<v-col cols="12" sm="6">
								<v-hover v-slot="{ hover }" close-delay="200">
									<v-card :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" class="mx-auto"
											height="160" max-width="200">
										<v-card-text class="font-weight-medium mt-12 text-center text-subtitle-1">
											Close Delay (Mouse leave)
										</v-card-text>
									</v-card>
								</v-hover>
							</v-col>
						</v-row>
					</div>
				</base-card>
			</v-col>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">#Hover list</div>
					<div slot="card-subheader">v-hover can be used in combination with v-for to make a single item
						stand out when the user interacts with the list.</div>
					<div slot="card-body">
						<v-container class="pa-4 text-center">
							<v-row align="center" justify="center">
								<template v-for="(item, i) in items">
									<v-col :key="i" cols="12" md="4">
										<v-hover v-slot="{ hover }">
											<v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }">
												<v-img :src="require(`../../assets/images/blog/${item.img}.jpg`)"
													   height="165px">
													<v-card-title class="text-h6 white--text">
														<v-row class="fill-height flex-column" justify="space-between">
															<p class="mt-4 subheading text-left">
																{{ item.title }}
															</p>

															<div>
																<p
																   class="ma-0 text-body-1 font-weight-bold font-italic text-left">
																	{{ item.text }}
																</p>
																<p
																   class="text-caption font-weight-medium font-italic text-left">
																	{{ item.subtext }}
																</p>
															</div>

															<div class="align-self-center">
																<v-btn v-for="(icon, index) in icons" :key="index"
																	   :class="{ 'show-btns': hover }"
																	   :color="transparent" icon>
																	<v-icon :class="{ 'show-btns': hover }"
																			:color="transparent">
																		{{ icon }}
																	</v-icon>
																</v-btn>
															</div>
														</v-row>
													</v-card-title>
												</v-img>
											</v-card>
										</v-hover>
									</v-col>
								</template>
							</v-row>
						</v-container>
					</div>
				</base-card>
			</v-col>
			<v-col class="col-12 col-md-12 col-sm-12">
				<base-card>
					<div slot="card-header">#Transition</div>
					<div slot="card-subheader">Create highly customized components that respond to user interaction.
					</div>
					<div slot="card-body">
						<v-hover v-slot="{ hover }">
							<v-card class="mx-auto" color="grey lighten-4" max-width="300">
								<v-img :aspect-ratio="16/9" src="../../assets/images/bg/4.jpg">
									<v-expand-transition>
										<div v-if="hover"
											 class="d-flex transition-fast-in-fast-out orange darken-2 v-card--reveal text-h2 white--text"
											 style="height: 100%;">
											$14.99
										</div>
									</v-expand-transition>
								</v-img>
								<v-card-text class="pt-6" style="position: relative;">
									<v-btn absolute color="orange" class="white--text" fab large right top>
										<v-icon>mdi-cart</v-icon>
									</v-btn>

								</v-card-text>
							</v-card>
						</v-hover>
					</div>
				</base-card>
			</v-col>
		</v-row>

	</div>

</template>
<script>
	import BaseCard from "../../components/Base/BaseCard.vue";
	import BaseHeader from '../../components/Base/BaseHeader'
	export default {
		components: {
			BaseCard,
			BaseHeader
		},
		data: () => ({
			icons: ['mdi-rewind', 'mdi-play', 'mdi-fast-forward'],
			items: [{
					title: 'New Releases',
					text: `It's New Release Friday`,
					subtext: 'Newly released songs. Updated daily.',
					img: '1',
				},
				{
					title: 'Rock',
					text: 'Greatest Rock Hits',
					subtext: 'Lose yourself in rock tunes.',
					img: '2',
				},
				{
					title: 'Mellow Moods',
					text: 'Ambient Bass',
					subtext: 'Chill beats to mellow you out.',
					img: '3',
				},
			],
			transparent: 'rgba(255, 255, 255, 0)',
		}),


	}
</script>

<!--====  End of HOVER  ====-->